import libraryService from "@apis/libraryService";
import { useFocusAction } from "@hooks/utils";

const useFocusActionClick = () => {
  const { cancelFocusSuccess } = useFocusAction();

  const cancelFocus = async (entityId: string, focusType: string) => {
    if (["video", "script"].includes(focusType)) {
      await libraryService.fetchDeleteCollection({
        id: entityId,
      });
    } else if (focusType === "video-generation") {
      await libraryService.fetchTrash(entityId);
    } else if (focusType === "product") {
      await libraryService.cancelEntity({
        entityId: entityId,
        groupType: focusType.toUpperCase(),
      });
    }
    cancelFocusSuccess(focusType);
  };

  return { cancelFocus };
};

export { useFocusActionClick };
